export enum SidebarMode {
  SEARCH = 'search',
  LAYERS = 'layers',
  FILTER = 'filter',
  EXPORT = 'export',
  CONTRIBUTE = 'contribute',
  BASKET = 'basket',
  HELP = 'help',
  CONTACT = 'contact',
}
